'use client';

import { type ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { ImportQueueRailContext, type ImportQueueRailContextValue } from './import-queue-rail-context';
const STORAGE_KEY = 'import-queue-rail-open';
interface ImportQueueRailProviderProps {
  children: ReactNode;
}
export function ImportQueueRailProvider({
  children
}: ImportQueueRailProviderProps) {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'true') {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- restore preference after mount (localStorage unavailable during SSR)
      setIsOpen(true);
    }
  }, []);
  const setOpen = useCallback((open: boolean) => {
    setIsOpen(open);
    window.localStorage.setItem(STORAGE_KEY, String(open));
  }, []);
  const value = useMemo<ImportQueueRailContextValue>(() => ({
    isOpen,
    setOpen
  }), [isOpen, setOpen]);
  return <ImportQueueRailContext.Provider value={value} data-sentry-element="ImportQueueRailContext.Provider" data-sentry-component="ImportQueueRailProvider" data-sentry-source-file="import-queue-rail-provider.tsx">
      {children}
    </ImportQueueRailContext.Provider>;
}